import { ComponentEntity } from "@backstage/catalog-model";
import { IconButton } from "@material-ui/core";
import React from 'react';
import { SonarIcon } from "../../icons";
import { SonarMetadataLinks, useSonarMetaLinks } from "./SonarTypeMetadataReader";

export const SonarComponentLinks = (props: { component: ComponentEntity }) => {

    const { metadata } = props.component;

    const links: SonarMetadataLinks = useSonarMetaLinks(metadata);

    return (<>
        {links.id && (
            <IconButton href={links.id} target="_blank">
                <SonarIcon />
            </IconButton>
        )}
    </>);
}

